// extracted by mini-css-extract-plugin
export default {"confirm":"styles_confirm__w5KFt"};